// ============================================================
// PERSONA LANDING PAGES — for targeted Facebook / TikTok ads
// ============================================================
// Add a new persona = add a new object here. Routes auto-generated as /for/<slug>.

export const PERSONAS = {
  housewife: {
    slug: "housewife",
    audienceLabel: "For Housewives",
    headline: "Earn From Home.",
    headlineAccent: "Without Leaving Your Family.",
    sub: "Join hundreds of Malaysian housewives earning extra income with INOCHI, Nano Shield and other affiliate programs — RM 0 capital, work from your phone, full training provided.",
    heroImage: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=1200&q=80&auto=format&fit=crop",
    ctaPrimary:   "Start Earning From Home",
    ctaSecondary: "See Real Income Stories",
    route: "/opportunities?type=affiliate",
    benefits: [
      { icon: "Heart",      title: "Family-First Schedule",   desc: "Work on your own time around school runs, naps and meals." },
      { icon: "Wallet",     title: "Zero Capital",            desc: "Start with RM 0 as an affiliate. No stock to buy." },
      { icon: "Smartphone", title: "Just Your Phone",         desc: "Promote with a link or QR code on WhatsApp & Instagram." },
      { icon: "Users",      title: "Community Support",       desc: "Join hundreds of other housewives learning together." },
    ],
    recommendedBrands: ["inochi", "nano-shield", "miresco-chocolate"],
  },
  "young-entrepreneur": {
    slug: "young-entrepreneur",
    audienceLabel: "For Young Entrepreneurs",
    headline: "Build Your First Business.",
    headlineAccent: "While You're Still Young.",
    sub: "Get a head start. Take on a kiosk, become an agent, or run your own territory with brands like SOUPWAY, MIRESCO Chocolate and Rollsmith. Mentorship and training included.",
    heroImage: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80&auto=format&fit=crop",
    ctaPrimary:   "Pick My First Business",
    ctaSecondary: "Browse All Opportunities",
    route: "/opportunities?type=kiosk",
    benefits: [
      { icon: "Rocket",     title: "Launch Fast",             desc: "Open your kiosk or agent business within weeks, not months." },
      { icon: "BookOpen",   title: "Built-In Training",       desc: "Learn sales, marketing & operations from established brands." },
      { icon: "Award",      title: "Proven Concepts",         desc: "No need to invent from scratch — run a tested franchise." },
      { icon: "TrendingUp", title: "Clear Growth Path",       desc: "Move from agent → stockist → distributor → territory owner." },
    ],
    recommendedBrands: ["soupway", "miresco-chocolate", "rollsmith"],
  },
  "business-owner": {
    slug: "business-owner",
    audienceLabel: "For Business Owners",
    headline: "Scale Your Business",
    headlineAccent: "Across All 16 States.",
    sub: "List your brand on MIRESCO and recruit affiliates, agents, stockists, distributors and influencers — all from one dashboard. Find investors and strategic partners while you grow.",
    heroImage: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?w=1200&q=80&auto=format&fit=crop",
    ctaPrimary:   "Apply As Vendor",
    ctaSecondary: "See Vendor Plans",
    route: "/vendor",
    external: true,
    benefits: [
      { icon: "Network",    title: "Nationwide Sales Force",  desc: "Tap into 320+ active affiliates and 45+ agents across Malaysia." },
      { icon: "Megaphone",  title: "Recruit Influencers",     desc: "Connect with vetted creators ready to promote your brand." },
      { icon: "Building2",  title: "Vendor Dashboard",        desc: "Manage applications, training and pay-outs in one place." },
      { icon: "Crown",      title: "Strategic Partners",      desc: "Find investors and JV partners to take you to the next level." },
    ],
    recommendedBrands: ["vendor-program", "inochi", "nano-shield"],
  },
};
